import React from 'react'
import { useMemo, useCallback } from 'sb-hooks'
import { array } from 'common/helpers'

import { Box, Row } from 'components/_new/layout'
import Svg from 'components/_new/ui/Svg/Svg'
import Text from 'components/_new/typography/Text/Text'
import { SelectableBoxView } from 'components/_new/controls'
import type { SelectableBoxViewProps } from 'components/_new/controls'

import messages from './messages'
import s from './SubscriptionPlan.scss'


type SubscriptionPlanProps = SelectableBoxViewProps & {
  price: string
  save?: string
  productsCount: number
  onSelect: (productsCount: number) => void
  dataTestId?: string
}

const SubscriptionPlan: React.FunctionComponent<SubscriptionPlanProps> = (props) => {
  const { price, save, active, withBg, productsCount, onSelect, dataTestId } = props

  const title   = useMemo(() => ({ ...messages.title, values: { productsCount } }), [ productsCount ])
  const bottles = useMemo(() => array.range(1, productsCount), [ productsCount ])

  const handleClick = useCallback(() => {
    onSelect(productsCount)
  }, [ productsCount, onSelect ])

  return (
    <SelectableBoxView
      className={s.container}
      active={active}
      withBg={withBg}
      onClick={handleClick}
      dataTestId={dataTestId}
    >
      <Row justify="start">
        <Box ml={8}>
          <Row
            className={s.bottles}
            justify="center"
          >
            {
              bottles.map((count) => (
                <Box key={count} mh={4}>
                  <Svg name="bottle" color="brand-30" />
                </Box>
              ))
            }
          </Row>
        </Box>
        <Row className={s.textContainer} justify="between">
          <Box ml={4}>
            <Text message={title} size="16-24" color="black" />
          </Box>
          <Box ml={4} mr={16} alignRight>
            <Text message={price} size="16-24" color="black" semibold />
            {
              Boolean(save) && (
                <Text message={save} size="14-16" color="brand" />
              )
            }
          </Box>
        </Row>
      </Row>
    </SelectableBoxView>
  )
}


export default SubscriptionPlan
